<template>
    <main>
        <div class="mx-auto pt-4 px-3">
            <nav v-if="getLoadingCategory" class="flex flex-wrap gap-2 overflow-y-hidden whitespace-nowrap max-h-6 justify-center sm:justify-start text-xs text-black transition-all ease-in-out duration-200">
               Carregando
            </nav>
            <nav v-else class="flex flex-wrap gap-2 overflow-y-hidden whitespace-nowrap max-h-6 justify-center sm:justify-start text-xs text-black transition-all ease-in-out duration-200">
                <button @click="categorySelected = null" 
                    :class="categorySelected == null ? 
                        'bg-blue-300 font-semibold text-blue-800' : 
                        'bg-blue-200 hover:bg-blue-300 hover:text-blue-800'"
                    class=" inline-flex rounded py-1 px-2"> 
                    Todos
                </button>
                <button v-for="(category, index) in getCategories" :key="index"
                    @click="categorySelected = category.id"
                    :class="categorySelected == category.id ? 
                        'bg-blue-300 font-semibold text-blue-800' : 
                        'bg-blue-200 hover:bg-blue-300 hover:text-blue-800'"
                    class=" inline-flex rounded py-1 px-2"> 
                    {{ category.name }} 
                </button>
            </nav>
        </div>
    </main>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
    export default {
        name: 'SugestoesComponent',
        components: {
        },
        data() {
          return {
            categorySelected: null
          }
        },
        methods: {
            ...mapActions(['fetchCategories', 'fetchBusca'])
        },
        mounted() {
            this.fetchCategories()
        },
        computed:{
            ...mapGetters(['getCategories', 'getLoadingCategory'])
        },
        watch: {
            categorySelected(newVal, oldVal) {
                if(newVal !== oldVal){
                    this.fetchBusca({
                        idCategory: newVal,
                        keyword: this.$store.state.aulas.keyword.trim(), 
                        pageNumber: 1
                    })
                }
            }
        },
    }
</script>